import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";

import FiltroContratoTarjeta from "./FiltroContratoTarjeta";
import CrearContratoTarjeta from "./CrearContratoTarjeta";
import EditarContratoTarjeta from "./EditarContratoTarjeta";
import EliminarContratoTarjeta from "./EliminarContratoTarjeta";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarContratoTarjeta() {
  // Paginación
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);

  // Datos
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Modales
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [registroAEditar, setRegistroAEditar] = useState(null);
  const [registroAEliminar, setRegistroAEliminar] = useState(null);

  // Filtros
 const [filtros, setFiltros] = useState({
  contratoObj: null,
  tarjetaObj: null,      // <-- NUEVO
  estadoObj: null,       // <-- NUEVO
  descripcionObj: null,
  data: "",
  dataFechaini: "",
  dataFechafin: "",
});

  const [reloadKey, setReloadKey] = useState(0);

  // Carga de datos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      console.log("🔍 [useEffect] filtros actuales:", filtros);
      console.log("🔍 [useEffect] tarjetaObj:", filtros.tarjetaObj);
      console.log("🔍 [useEffect] tarjetaObj?.id:", filtros.tarjetaObj?.id);

      try {
        let baseUrl = apiRoutes.contratoTarjeta.listUrl({});
        if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];

        const queryParams = new URLSearchParams();
        queryParams.append("page", pagina - 1);
        queryParams.append("size", porPagina);
        if (filtros.contratoObj?.id) queryParams.append("contratoId", filtros.contratoObj.id);
        if (filtros.tarjetaObj?.id) queryParams.append("tarjetaId", filtros.tarjetaObj.id);
        if (filtros.estadoObj?.id) queryParams.append("estadoId", filtros.estadoObj.id);
        if (filtros.descripcionObj?.descricaoTexto) queryParams.append("descricaoTexto", filtros.descripcionObj.descricaoTexto);

        console.log("🔍 [URL] queryParams.toString():", queryParams.toString());

        const url = `${baseUrl}?${queryParams.toString()}`;

        console.log("📡 URL FINAL que se va a consultar:", url);
        
        const res = await appFetchJson(url);

        const items = Array.isArray(res?.items) ? res.items : (Array.isArray(res?.content) ? res.content : []);
        setData(items);
        const total = res?.totalElements ?? res?.total ?? items.length;
        setTotalBackend(total);
      } catch (e) {
        console.error("Error cargando relaciones contrato-tarjeta:", e);
        setError("Error al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  // Definición de columnas
  const columns = [
    {
      header: "Código de Contrato",
      accessor: "contratoCodigo",
      type: "text",
      width: "35%",
      cellClass: "font-medium text-gray-800",
    },
    {
      header: "Estado del Contrato",
      accessor: "estadoNombre",
      type: "text",
      width: "30%",
      cellClass: "text-gray-700",
    },
    {
      header: "Tarjeta del Contrato",
      accessor: "tarjetaNumero",
      type: "text",
      width: "30%",
      cellClass: "font-mono text-gray-700",
    },
    {
      header: "Acción",
      type: "action",
      width: "10%",
      render: (item) => (
        <div className="flex justify-center items-center gap-2">
          {/* <button
            className="p-1"
            title="Editar"
            onClick={() => setRegistroAEditar(item)}
          >
            <IconEdit size={16} />
          </button> */}
          
          <button
            className="p-1"
            title="Eliminar"
            onClick={() => setRegistroAEliminar(item)}
          >
            <IconTrash size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Asignación de Contratos a Tarjetas"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}

       onClearFilters={() => {
  setFiltros({
    contratoObj: null,
    tarjetaObj: null,
    estadoObj: null,
    descripcionObj: null,
    data: "",
    dataFechaini: "",
    dataFechafin: "",
  });
  setPagina(1);
}}
        showAdd={false}
        addLabel="Nueva Asignación"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-2 text-sm text-center text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroContratoTarjeta
          initialFilters={filtros}

          onSubmit={(nuevosFiltros) => {

          console.log("🟢 Filtros recibidos en onSubmit:", nuevosFiltros);
          console.log("🟢 tarjetaObj:", nuevosFiltros.tarjetaObj);
          console.log("🟢 tarjetaObj.id:", nuevosFiltros.tarjetaObj?.id);

  setFiltros({
    contratoObj: nuevosFiltros.contratoObj,
    tarjetaObj: nuevosFiltros.tarjetaObj,    // <-- NUEVO
    estadoObj: nuevosFiltros.estadoObj,      // <-- NUEVO
    descripcionObj: nuevosFiltros.descripcionObj,
    data: nuevosFiltros.data,
    dataFechaini: nuevosFiltros.dataFechaini,
    dataFechafin: nuevosFiltros.dataFechafin,
  });
  setPagina(1);
  setMostrarFiltros(false);
}}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {!loading && <DynamicTable size="M" data={data} columns={columns} />}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {/* Modal Crear */}
      {mostrarCrear && (
        <CrearContratoTarjeta
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setReloadKey((k) => k + 1);
            setMostrarCrear(false);
          }}
        />
      )}

      {/* Modal Editar */}
      {registroAEditar && (
        <EditarContratoTarjeta
          initial={registroAEditar}
          onClose={() => setRegistroAEditar(null)}
          onSaved={() => {
            setReloadKey((k) => k + 1);
            setRegistroAEditar(null);
          }}
        />
      )}

      {/* Modal Eliminar */}
      {registroAEliminar && (
        <div className="modal-backdrop" onClick={() => setRegistroAEliminar(null)}>
          <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
            <EliminarContratoTarjeta
              registro={registroAEliminar}
              onClose={() => setRegistroAEliminar(null)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setRegistroAEliminar(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}